export default __webpack_public_path__ + "static/media/launch.bff1d99e.png";